// SuperAdmin Action Types
export const FETCH_AGENCY_LIST = 'superAdmin/fetchAgencyList';
export const FETCH_AGENCY_LIST_REQUEST = 'superAdmin/fetchAgencyListRequest';
export const FETCH_AGENCY_LIST_SUCCESS = 'superAdmin/fetchAgencyListSuccess';
export const FETCH_AGENCY_LIST_FAILURE = 'superAdmin/fetchAgencyListFailure';

export const FETCH_ORDERS = 'superAdmin/fetchOrders';
export const FETCH_ORDERS_REQUEST = 'superAdmin/fetchOrdersRequest';
export const FETCH_ORDERS_SUCCESS = 'superAdmin/fetchOrdersSuccess';
export const FETCH_ORDERS_FAILURE = 'superAdmin/fetchOrdersFailure';

export const FETCH_ACCOUNT_DETAILS = 'superAdmin/fetchAccountDetails';
export const FETCH_ACCOUNT_DETAILS_REQUEST = 'superAdmin/fetchAccountDetailsRequest';
export const FETCH_ACCOUNT_DETAILS_SUCCESS = 'superAdmin/fetchAccountDetailsSuccess';
export const FETCH_ACCOUNT_DETAILS_FAILURE = 'superAdmin/fetchAccountDetailsFailure';

export const DOWNLOAD_AGENCY_TEMPLATE = 'superAdmin/downloadAgencyTemplate';
export const DOWNLOAD_AGENCY_TEMPLATE_REQUEST = 'superAdmin/downloadAgencyTemplateRequest';
export const DOWNLOAD_AGENCY_TEMPLATE_SUCCESS = 'superAdmin/downloadAgencyTemplateSuccess';
export const DOWNLOAD_AGENCY_TEMPLATE_FAILURE = 'superAdmin/downloadAgencyTemplateFailure';

export const UPLOAD_AGENCY_FUNDS = 'superAdmin/uploadAgencyFunds';
export const UPLOAD_AGENCY_FUNDS_REQUEST = 'superAdmin/uploadAgencyFundsRequest';
export const UPLOAD_AGENCY_FUNDS_SUCCESS = 'superAdmin/uploadAgencyFundsSuccess';
export const UPLOAD_AGENCY_FUNDS_FAILURE = 'superAdmin/uploadAgencyFundsFailure';

export const SET_ACTIVE_TAB = 'superAdmin/setActiveTab';
export const SET_ORDERS_FILTERS = 'superAdmin/setOrdersFilters';
export const CLEAR_ERROR = 'superAdmin/clearError';
export const CLEAR_TEMPLATE_DOWNLOAD_SUCCESS = 'superAdmin/clearTemplateDownloadSuccess';
export const CLEAR_AGENCY_FUNDS_UPLOAD_SUCCESS = 'superAdmin/clearAgencyFundsUploadSuccess';

// Action Creators
export const fetchAgencyList = (payload = {}) => ({
  type: FETCH_AGENCY_LIST,
  payload,
});

export const fetchOrders = (payload = {}) => ({
  type: FETCH_ORDERS,
  payload,
});

export const fetchAccountDetails = (payload = {}) => ({
  type: FETCH_ACCOUNT_DETAILS,
  payload,
});

export const downloadAgencyTemplate = (payload = {}) => ({
  type: DOWNLOAD_AGENCY_TEMPLATE,
  payload,
});

export const uploadAgencyFunds = (payload = {}) => ({
  type: UPLOAD_AGENCY_FUNDS,
  payload,
});

export const setActiveTab = (payload = {}) => ({
  type: SET_ACTIVE_TAB,
  payload,
});

export const setOrdersFilters = (payload = {}) => ({
  type: SET_ORDERS_FILTERS,
  payload,
});

export const clearError = (payload = {}) => ({
  type: CLEAR_ERROR,
  payload,
});

export const clearTemplateDownloadSuccess = (payload = {}) => ({
  type: CLEAR_TEMPLATE_DOWNLOAD_SUCCESS,
  payload,
});

export const clearAgencyFundsUploadSuccess = (payload = {}) => ({
  type: CLEAR_AGENCY_FUNDS_UPLOAD_SUCCESS,
  payload,
});

